import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from "@core/services/api.service";
import { ApiServiceHolder } from "@core/utils/api-service-holder";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { MemoEditorComponent } from '../memo-editor/memo-editor.component';

@Component({
  selector: 'app-start-conversation',
  templateUrl: './start-conversation.component.html',
  styleUrls: ['./start-conversation.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    FormsModule,
    MemoEditorComponent,
  ]
})
export class StartConversationComponent implements OnInit {
  @Input() IDUserRecipient:number;
  @Input() UserRecipientName:string;
  @Input() IDAuction:number;
  @Input() IDArticle:number;
  messageContent:string = '';
  @Input() subject: string = '';
  @Output() onMessageSaved: EventEmitter<void> = new EventEmitter();

  constructor(public activeModal: NgbActiveModal, private apiService: ApiService, private _translate: TranslateService) { }

  ngOnInit(): void {
  }

  saveMessageClicked() {
    this.apiService.request(ApiServiceHolder.message.startConversation({
      Conversation:{
        IDArticle: this.IDArticle,
        IDAuction: this.IDAuction,
        Subject: this.subject
      },
      Message:{
        IDUserRecipient: this.IDUserRecipient,
        Contents: this.messageContent,
        IDThread: -1
      }
    })).subscribe(() => {
      Swal.fire(this._translate.instant('IDS_MESSAGE_SENT'));
      this.activeModal.close();
      this.onMessageSaved.emit();
    });
  }
}
